/**
 * HeatmapTooltip Component
 * Hover tooltip showing day details for the activity heatmap
 */

import { formatDateForTooltip } from './heatmapUtils'

/**
 * Tooltip component for heatmap cells
 * @param {Object} props - Component props
 * @param {Object} props.data - Activity data for the day
 * @param {Date} props.date - Date object for the day
 * @param {Object} props.position - Tooltip position { x, y }
 * @param {boolean} props.visible - Whether tooltip is visible
 */
function HeatmapTooltip({ data, date, position, visible }) {
  if (!visible || !date) return null

  const formattedDate = formatDateForTooltip(date)
  const hasActivity = data && data.count > 0

  return (
    <div
      className="fixed z-50 pointer-events-none transition-opacity duration-150"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(-50%, -100%)',
        marginTop: '-8px',
        opacity: visible ? 1 : 0
      }}
    >
      <div className="bg-gray-900 dark:bg-gray-800 text-white text-xs rounded-lg px-3 py-2 shadow-lg min-w-[160px]">
        <div className="font-medium mb-1">{formattedDate}</div>
        {hasActivity ? (
          <>
            <div className="text-gray-300">
              <span className="font-semibold text-white">{data.count}</span> {data.count === 1 ? 'question' : 'questions'} answered
            </div>
            {(data.challenges > 0 || data.questions > 0) && (
              <div className="text-gray-400 text-[10px] mt-1">
                {data.challenges > 0 && (
                  <span>{data.challenges} {data.challenges === 1 ? 'challenge' : 'challenges'}</span>
                )}
              </div>
            )}
          </>
        ) : (
          <div className="text-gray-400">No activity</div>
        )}
        {/* Tooltip arrow */}
        <div
          className="absolute left-1/2 bottom-0 transform -translate-x-1/2 translate-y-full"
          style={{
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid rgb(17, 24, 39)'
          }}
        />
      </div>
    </div>
  )
}

export default HeatmapTooltip
